import React from 'react';
import { Typography } from '@mui/material';
import CandidateSection from './CandidateSection';
import Timeline from './Timeline';

const CandidateEducation = ({ education }) => (
    <CandidateSection title="Education">
        {education?.length > 0 ? (
            <Timeline
                items={education}
                getTitle={(item) => item.degree}
                getSubtitle={(item) => item.institution}
            />
        ) : (
            <Typography variant="body2" color="text.secondary">No education history listed</Typography>
        )}
    </CandidateSection>
);

export default CandidateEducation;
